import React, { useEffect, useState } from 'react';
import { StarIcon } from 'lucide-react';
const purchases = [{
  name: 'Juan P.',
  city: 'Córdoba',
  province: 'Córdoba'
}, {
  name: 'María S.',
  city: 'Rosario',
  province: 'Santa Fe'
}, {
  name: 'Lucas M.',
  city: 'Mendoza',
  province: 'Mendoza'
}, {
  name: 'Sofía G.',
  city: 'La Plata',
  province: 'Buenos Aires'
}, {
  name: 'Diego R.',
  city: 'Salta',
  province: 'Salta'
}, {
  name: 'Valentina B.',
  city: 'Neuquén',
  province: 'Neuquén'
}, {
  name: 'Mateo L.',
  city: 'San Miguel',
  province: 'Tucumán'
}, {
  name: 'Camila F.',
  city: 'Mar del Plata',
  province: 'Buenos Aires'
}, {
  name: 'Nicolás T.',
  city: 'Posadas',
  province: 'Misiones'
}, {
  name: 'Agustina V.',
  city: 'Resistencia',
  province: 'Chaco'
}, {
  name: 'Facundo D.',
  city: 'Bahía Blanca',
  province: 'Buenos Aires'
}, {
  name: 'Martina K.',
  city: 'Santa Fe',
  province: 'Santa Fe'
}, {
  name: 'Joaquín H.',
  city: 'San Juan',
  province: 'San Juan'
}, {
  name: 'Lucía M.',
  city: 'Corrientes',
  province: 'Corrientes'
}, {
  name: 'Santiago N.',
  city: 'San Salvador',
  province: 'Jujuy'
}, {
  name: 'Elena W.',
  city: 'Bariloche',
  province: 'Río Negro'
}, {
  name: 'Tomás C.',
  city: 'Paraná',
  province: 'Entre Ríos'
}, {
  name: 'Rocío J.',
  city: 'Formosa',
  province: 'Formosa'
}, {
  name: 'Bautista E.',
  city: 'Catamarca',
  province: 'Catamarca'
}, {
  name: 'Milagros Q.',
  city: 'La Rioja',
  province: 'La Rioja'
}];
export function SocialProofPopup() {
  const [index, setIndex] = useState(0);
  const [isVisible, setIsVisible] = useState(false);
  const [isExiting, setIsExiting] = useState(false);
  const [timeAgo, setTimeAgo] = useState('hace 2 minutos');
  useEffect(() => {
    const showTimer = setTimeout(() => setIsVisible(true), 2000);
    const cycleInterval = setInterval(() => {
      setIsExiting(true);
      setTimeout(() => {
        setIsVisible(false);
        setIsExiting(false);
        setIndex(prev => (prev + 1) % purchases.length);
        const minutes = Math.floor(Math.random() * 45) + 1;
        setTimeAgo(`hace ${minutes} minutos`);
        setIsVisible(true);
      }, 300);
    }, 10000);
    return () => {
      clearTimeout(showTimer);
      clearInterval(cycleInterval);
    };
  }, []);
  const current = purchases[index];
  if (!isVisible) return null;
  return <div className="fixed bottom-4 left-4 z-[100] pointer-events-none" data-id="element-187">
      <div className={`bg-brand-navy border border-white/10 p-4 rounded-xl shadow-2xl flex items-center gap-4 max-w-[280px] pointer-events-auto ${isExiting ? 'animate-fade-out-down' : 'animate-fade-in-up'}`} data-id="element-188">
        <div className="w-10 h-10 bg-brand-green/20 rounded-full flex items-center justify-center shrink-0" data-id="element-189">
          <StarIcon size={20} className="text-brand-gold fill-brand-gold" data-id="element-190" />
        </div>
        <div data-id="element-191">
          <div className="text-sm font-bold text-white" data-id="element-192">
            {current.name} acaba de comprar
          </div>
          <div className="text-[10px] text-gray-500 mb-0.5" data-id="element-193">{timeAgo}</div>
          <div className="text-xs text-gray-400" data-id="element-194">
            {current.city}, {current.province}
          </div>
          <div className="flex items-center gap-1 mt-1" data-id="element-195">
            <StarIcon size={10} className="text-brand-gold fill-brand-gold" data-id="element-196" />
            <span className="text-[10px] font-bold text-brand-green uppercase tracking-wider" data-id="element-197">
              Compra verificada
            </span>
          </div>
        </div>
      </div>
    </div>;
}